import { render, staticRenderFns } from "./CommentChoiceToggle.vue?vue&type=template&id=283d3b36&scoped=true&"
import script from "./CommentChoiceToggle.vue?vue&type=script&lang=ts&"
export * from "./CommentChoiceToggle.vue?vue&type=script&lang=ts&"
import style0 from "./CommentChoiceToggle.vue?vue&type=style&index=0&id=283d3b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d3b36",
  null
  
)

export default component.exports